import PropTypes from 'prop-types';
import React, { useState } from 'react';
import circleExitRed from '../img/circle-exit-red.svg';
import circleExitWhite from '../img/circle-exit-white.svg';

import SecondaryButton from "./SecondaryButton";

function CloseButton({
  onClick,
  label,
  // mode,
  size,
  tabable,
  name,
  id
}: {
  onClick: VoidFunction,
  label?: string,
  mode?: 'regular'|'light',
  size?: string|undefined,
  tabable?: boolean|undefined,
  name?: string|undefined
  id?: string|undefined
}) {
  const [isMouseOver, setIsMouseOver] = useState(false);
  // if(mode === 'light') {
  //   return (
  //     <SecondaryButton size={size || 'regular'} onClick={onClick}>
  //       <div className="ifms-close-btn-icon">&nbsp;<FontAwesomeIcon icon={faTimes} />&nbsp;</div>&nbsp;{label || `Close`}
  //     </SecondaryButton>
  //   );
  // }

  return (
    <SecondaryButton  notsetbackcolorwhenfocus="b" id={id} onMouseEnter={() => { setIsMouseOver(true) }} onMouseLeave={() => { setIsMouseOver(false) }} style={{ padding: '1px 6px 1px 10px' }} name={name} size={size || 'regular'} onClick={onClick} tabIndex={tabable ? '' : '-1'}>
      <span style={{ position: 'relative', top: '1px' }}>{label || 'Close'}</span><img style={{ width: '18px' }} src={isMouseOver ? circleExitWhite : circleExitRed} alt='' />
    </SecondaryButton>
  );
}


CloseButton.defaultProps = {
  label: 'Close',
  mode: 'regular',
  tabable : true
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  mode: PropTypes.oneOf(['regular', 'light']),
  size: PropTypes.string,
  tabable: PropTypes.bool
};

export default React.memo(CloseButton);